<template>
    <div class="detail-year-amount">
        <van-nav-bar
            title="量"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
            @click-right="showFilterPop = true"
        >
            <template #title>
                <img class="nav_title" src="../../../assets/images/leadingCockpit/liang_nav.png">
            </template>
            <template #right>
                <img class="shaixuan" src="../../../assets/images/leadingCockpit/shaixuan.png">
            </template>
        </van-nav-bar>
        <div class="container-wrapper">
            <filterConditions
                :show-filter-pop.sync="showFilterPop"
                :date="date"
                @sureBack="sureBack"
            ></filterConditions>
            <div class="data-box">
                <div class="data-item left">
                    <div class="name">
                        当月销量(万方)
                        <div class="num month">
                            {{ monthMount }}
                        </div>
                    </div>
                </div>
                <div class="data-item right">
                    <div class="name">
                        年累计销量(万方)
                        <div class="num year">
                            {{ yearMount }}
                        </div>
                    </div>
                    <div class="name">
                        同比(万方)
                        <p class="num tb">
                            {{ samePerc }}
                        </p>
                    </div>
                </div>
            </div>
            <div class="charts-panel">
                <div class="title">
                    月度销量环比
                </div>
                <div id="charts1" class="charts-box">
                </div>
                <div class="paginate" v-if="this.monthRingPageList.length>1">
                    <span
                        v-for="index in this.monthRingPageList.length"
                        :key="index"
                        :class="{active:ringPage==index-1}"
                        @click="changeRingPage(index-1)"
                    ></span>
                </div>
            </div>
            <div class="bg-line"></div>
            <div class="charts-panel">
                <div class="title">
                    月度销量同比
                </div>
                <div id="charts2" class="charts-box">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import filterConditions from './filterConditions/index';
export default {
    name: 'detail-year-amount',
    components: { filterConditions },
    data() {
        return {
            date: {
                startDate: '',
                endDate: '',
            },
            showFilterPop: false,
            filterParams: {},
            monthMount: 0, // 当月销量
            yearMount: 0, // 年累计销量
            samePerc: 0, // 同比
            monthRingPageList: [], // 月度销量环比 分页
            ringPage: 0,
            ringPageTotal: 0,
            monthSameList: [], // 月度销量同比
        };
    },
    created() {
        this.date.startDate = this.$route.params.startDate;
        this.date.endDate = this.$route.params.endDate;
        this.filterParams = Object.assign({}, this.date);
    },
    mounted() {
        this.getData();
    },
    methods: {
        async getData() {
            this.getRingData().then(data => {
                if (data.list.length > 0) {
                    this.monthMount = data.list[data.list.length - 1].quantity;
                } else {
                    this.monthMount = 0;
                }
                for (let i = 0; i < data.list.length; i += 5) {
                    const list = data.list.slice(i, i + 5);
                    const lastList = data.list_last.slice(i, i + 5);
                    this.monthRingPageList.push({
                        list: list,
                        list_last: lastList,
                    });
                }
                this.initRingChart();
            });
            this.getSameData().then(data => {
                this.monthSameList = data;
                this.yearMount = data.quantity_year;
                this.samePerc = data.quantity_lastyear;
                this.initSameChart();
            });
        },
        // 改变echart 页
        changeRingPage(index) {
            this.ringPage = index;
            this.initRingChart();
        },
        sureBack(pamams) {
            this.filterParams = pamams;
            this.getData();
        },
        // 时间格式处理
        formatDate(date) {
            date = new Date(date);
            const y = date.getFullYear();
            let m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            return y + '-' + m;
        },
        // 企业月度销量 环比
        async initRingChart() {
            const myChart = this.$echarts.init(document.getElementById('charts1'));
            const xdata = [];
            const ydata = [
                { name: '本月', colors: ['#76E0A8', '#13BD63'], data: [] },
                { name: '上月', colors: ['#EFAB54', '#FA8C47'], data: [] },
            ];
            const list = this.monthRingPageList[this.ringPage].list;
            const prevList = this.monthRingPageList[this.ringPage].list_last;
            list.forEach((item, index) => {
                xdata.push(item.org_name);
                ydata[0].data.push(item.quantity);
                ydata[1].data.push(prevList[index].quantity);
            });
            const newOption = {
                title: {
                    text: '单位（万方）',
                    textStyle: {
                        color: 'rgba(255,255,255,0.5)',
                        fontSize: 10,
                    },
                },
                animationEasing: 'elasticOut',
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                    },
                },
                legend: {
                    right: 15,
                    itemWidth: 12,
                    itemHeight: 10,
                    data: ['本月', '上月'],
                    textStyle: {
                        color: 'rgba(255,255,255,0.5)',
                        fontSize: 10,
                    },
                },
                grid: {
                    top: '30',
                    left: '30',
                    right: '20',
                    bottom: '55',
                },
                xAxis: {
                    type: 'category',
                    data: xdata,
                    axisLabel: {
                        // 坐标轴刻度标签的相关设置。
                        interval: 0, // 设置为 1，表示『隔一个标签显示一个标签』
                        rotate: 50,
                        textStyle: {
                            color: 'rgba(255,255,255,0.5)',
                            fontStyle: 'normal',
                            fontFamily: '微软雅黑',
                            fontSize: 10,
                        },
                    },
                    axisTick: {
                        // 坐标轴刻度相关设置。
                        show: false,
                    },
                    axisLine: {
                        // 坐标轴轴线相关设置
                        lineStyle: {
                            color: '#D8D8D8',
                            opacity: 0.3,
                        },
                    },
                    splitLine: {
                        // 坐标轴在 grid 区域中的分隔线。
                        show: false,
                        lineStyle: {
                            color: '#E5E9ED',
                        },
                    },
                },
                yAxis: [
                    {
                        axisLabel: {
                            // 坐标轴刻度标签的相关设置。
                            interval: 0, // 设置为 1，表示『隔一个标签显示一个标签』
                            //	margin:15,
                            textStyle: {
                                color: 'rgba(255,255,255,0.5)',
                                fontStyle: 'normal',
                                fontFamily: '微软雅黑',
                                fontSize: 10,
                            },
                        },
                        axisTick: {
                            // 坐标轴刻度相关设置。
                            show: false,
                        },
                        axisLine: {
                            // 坐标轴轴线相关设置
                            lineStyle: {
                                color: '#D8D8D8',
                                opacity: 0.3,
                            },
                        },
                        splitLine: {
                            // 坐标轴在 grid 区域中的分隔线。
                            show: true,
                            lineStyle: {
                                color: '#fff',
                                opacity: 0.1,
                                type: 'dashed',
                            },
                        },
                    },
                ],
                series: [],
            };
            ydata.forEach(item => {
                newOption.series.push(
                    {
                        name: item.name,
                        type: 'bar',
                        barMaxWidth: 18,
                        silent: true,
                        itemStyle: {
                            normal: {
                                color: new window.$globalHub.$echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        { offset: 0, color: item.colors[0] },
                                        { offset: 1, color: item.colors[1] },
                                    ]
                                ),
                            },
                        },
                        label: {
                            show: false,
                            position: [-10, -10],
                            distance: 2,
                            width: 30,
                            height: 12,
                            color: '#01C8FE',
                            fontWeight: 'bolder',
                            fontSize: 12,
                            align: 'center',
                            lineHeight: 16,
                            padding: [0, 10, 0, 10],
                        },
                        emphasis: {
                            focus: 'series',
                        },
                        z: 1,
                        animationEasing: 'elasticOut',
                        data: item.data,
                    },
                    {
                        type: 'pictorialBar',
                        itemStyle: {
                            normal: {
                                color: '#0e1c31',
                            },
                        },
                        tooltip: {
                            show: false,
                        },
                        symbolRepeat: 'fixed',
                        symbolMargin: 3,
                        symbol: 'rect',
                        symbolClip: true,
                        symbolSize: [70, 2],
                        symbolPosition: 'start',
                        symbolOffset: [0, 6],
                        z: 2,
                        animationEasing: 'elasticOut',
                        data: item.data,
                    }
                );
            });
            myChart.setOption(newOption, true );
        },
        async initSameChart() {
            const myChart = this.$echarts.init(document.getElementById('charts2'));
            const list = this.monthSameList.list; // 本月数据
            const prevList = this.monthSameList.list_last; // 上月数据
            const xdata = [];
            const ydata = {
                list: {
                    name: '',
                    data: [],
                },
                prevList: {
                    name: '',
                    data: [],
                },
            };
            list.forEach(item => {
                if (!ydata.list.name) {
                    ydata.list.name = item.year_dim + '年每月销量';
                }
                xdata.push(item.month_dim + '月');
                ydata.list.data.push(item.quantity);
            });
            prevList.forEach(item => {
                if (!ydata.prevList.name) {
                    ydata.prevList.name = item.year_dim + '年每月销量';
                }
                ydata.prevList.data.push(item.quantity);
            });

            const option = {
                title: {
                    text: '单位（万方）',
                    textStyle: {
                        color: 'rgba(255,255,255,0.5)',
                        fontSize: 10,
                    },
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                    },
                },
                legend: {
                    right: 15,
                    itemWidth: 12,
                    itemHeight: 10,
                    data: [ydata.list.name, ydata.prevList.name],
                    textStyle: {
                        color: 'rgba(255,255,255,0.5)',
                        fontSize: 10,
                    },
                },
                grid: {
                    top: '50',
                    left: '30',
                    right: '20',
                    bottom: '36',
                },
                dataZoom: [// 给x轴设置滚动条
                    {
                        startValue: 0,
                        endValue: 5,
                        type: 'slider',
                        show: xdata.length > 5,
                        handleSize: 0, // 滑动条的 左右2个滑动条的大小
                        moveHandleSize: 0, // 滑动条的 左右2个滑动条的大小
                        height: 6, // 组件高度
                        left: '8%', // 左边的距离
                        right: '6%', // 右边的距离
                        bottom: 6, // 右边的距离
                        borderColor: '#000',
                        fillerColor: 'rgba(0, 150, 248, 1)',
                        borderRadius: 5,
                        backgroundColor: 'rgba(255,255,255,0.2)', // 两边未选中的滑动条区域的颜色
                        showDataShadow: false, // 是否显示数据阴影 默认auto
                        showDetail: false, // 即拖拽时候是否显示详细数值信息 默认true
                        realtime: true, // 是否实时更新
                    },
                    // 下面这个属性是里面拖到
                    {
                        type: 'inside',
                        show: false,
                        startValue: 0,
                        endValue: 5,
                    },
                ],
                xAxis: {
                    type: 'category',
                    data: xdata,
                    axisLabel: {
                        // 坐标轴刻度标签的相关设置。
                        interval: 0, // 设置为 1，表示『隔一个标签显示一个标签』
                        //	margin:15,
                        textStyle: {
                            color: 'rgba(255,255,255,0.5)',
                            fontStyle: 'normal',
                            fontFamily: '微软雅黑',
                            fontSize: 10,
                        },
                    },
                    axisTick: {
                        // 坐标轴刻度相关设置。
                        show: false,
                    },
                    axisLine: {
                        // 坐标轴轴线相关设置
                        lineStyle: {
                            color: '#fff',
                            opacity: 0.3,
                        },
                    },
                    splitLine: {
                        // 坐标轴在 grid 区域中的分隔线。
                        show: false,
                    },
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        // 坐标轴刻度标签的相关设置。
                        interval: 0, // 设置为 1，表示『隔一个标签显示一个标签』
                        textStyle: {
                            color: 'rgba(255,255,255,0.5)',
                            fontStyle: 'normal',
                            fontFamily: '微软雅黑',
                            fontSize: 10,
                        },
                    },
                    axisTick: {
                        // 坐标轴刻度相关设置。
                        show: false,
                    },
                    axisLine: {
                        // 坐标轴轴线相关设置
                        lineStyle: {
                            color: '#fff',
                            opacity: 0.3,
                        },
                    },
                    splitLine: {
                        // 坐标轴在 grid 区域中的分隔线。
                        show: true,
                        lineStyle: {
                            type: 'dashed',
                            color: '#fff',
                            opacity: 0.1,
                        },
                    },
                },
                series: [
                    {
                        name: ydata.list.name,
                        type: 'bar',
                        data: ydata.list.data,
                        barWidth: '15',
                        barMinHeight: '1',
                        label: {
                            show: false,
                            position: 'top',
                            distance: 2,
                            height: 12,
                            color: '#01C8FE',
                            fontWeight: 'bolder',
                            fontSize: 12,
                            // formatter: '{c}',
                            align: 'center',
                            lineHeight: 22,
                            padding: [0, 10, 0, 10],
                            // backgroundColor: {
                            //     image: bg_blue,
                            //     height: 0.6,
                            // },
                        },
                        itemStyle: {
                            normal: {
                                color: new window.$globalHub.$echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        { offset: 0, color: '#01C8FE' },
                                        { offset: 1, color: '#076DFD' },
                                    ]
                                ),
                            },
                        },
                    },
                    {
                        name: ydata.prevList.name,
                        type: 'bar',
                        data: ydata.prevList.data,
                        barWidth: '15',
                        barMinHeight: '1',
                        label: {
                            show: false,
                            position: 'top',
                            distance: 0,
                            height: 12,
                            color: '#FCEF20',
                            fontWeight: 'bolder',
                            fontSize: 12,
                            formatter: '{c}',
                            align: 'center',
                            lineHeight: 22,
                            padding: [0, 10, 0, 10],
                            // backgroundColor: {
                            //     image: bg_orange,
                            //     height: 0.6,
                            // },
                        },
                        itemStyle: {
                            normal: {
                                color: new window.$globalHub.$echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        { offset: 0, color: '#FCEF20' },
                                        { offset: 1, color: '#FEBD29' },
                                    ]
                                ),
                            },
                        },
                    },
                ],
            };
            myChart.setOption(option, true);
        },
        // 获取月度数据 环比
        getRingData() {
            const url = '/interfaceApi/report/leadercockpit/tenant_quantity';
            const data = this.filterParams;
            return this.$axios.post(url, data);
        },
        // 获取月统计数据 同比
        getSameData() {
            const url = '/interfaceApi/report/leadercockpit/monthly_quantity';
            const data = this.filterParams;
            return this.$axios.post(url, data);
        },
        // 获取企业计数据
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 跳转页面
        to(path) {
            this.$router.isBack = 2;
            this.$router.push({ name: path });
        },
    },
};
</script>
<style  lang="stylus">
.detail-year-amount
    background url('../../../assets/images/leadingCockpit/bg.png') #0E1C31
    background-size 100%
    padding-bottom 20rpx;
    .van-nav-bar
        background #001F4C!important;
        .shaixuan
            width 18rpx;
    .nav_title
        margin-top 10rpx
        width 52rpx;
    .container-wrapper
        height calc(100% - 20rpx)
        overflow-y auto
    .bg-line
        height 15rpx;
        background rgba(0,0,0,0.5);
    .filterConditions
        display flex
        height 40rpx
        padding 15rpx 10rpx
        width 94%;
        margin: 13rpx auto 0;
        background url("../../../assets/images/leadingCockpit/bg_secondary_page_1.png") no-repeat center
        background-size 100%
        justify-content center
        align-items center
        .line
            width: 20rpx;
            height: 2px;
            background: rgba(255, 255, 255, 0.2);
        .time
            width 80rpx
            height 30rpx
            line-height 28rpx
            margin 0 5rpx
            position relative
            input
                width 130rpx
                height 30rpx
                border none
                text-indent 30rpx
                background: transparent;
                font-size 14rpx;
                color:#fff;
                font-family: Technology-Regular, Technology;
            &:before
                line-height 30rpx
                font-size 16rpx
                color #0096F8
                position absolute
                left 5rpx
    .data-box
        display flex
        justify-content space-between
        padding 15rpx;
        .data-item
            background: #12243D;
            border: 1px solid #27436C;
            .name
                font-size: 12rpx;
                color #fff;
            .num
                margin-top: 2rpx;
                font-size: 18rpx;
                font-family: Technology-Regular, Technology;
                text-align center
            &.left
                display flex
                flex-direction column;
                justify-content center
                align-items center;
                width: 112rpx;
                height: 52rpx;
                .num
                    color: #03B0FE;
            &.right
                width: 220rpx;
                height: 52rpx;
                display flex
                align-items center
                .name
                    &:nth-child(1)
                        width 114rpx;
                        padding-left 20rpx;
                        .num
                            color: #FDDC24;
                    &:nth-child(2)
                        margin-left 30rpx;
                        .num
                            color: #FF2F2F;
    .charts-panel
        padding 15rpx;
        .title
            font-size 16rpx;
            color:#fff;
        .charts-box
            padding-top 20rpx;
            height 250rpx;
        .paginate
            display flex
            justify-content center
            span
                display flex
                width 50rpx;
                height 5rpx;
                background rgba(255,255,255,0.2)
                margin 4rpx
                &.active
                    background rgba(0, 150, 248, 1)
        .sort-box
            padding-top 15rpx;
            >div
                display flex
                justify-content space-around
                span
                    display flex
                    justify-content center
                    align-items center
                    &:nth-child(1)
                        width 52rpx
                    &:nth-child(2)
                        width 52rpx
                    &:nth-child(3)
                        width 110rpx
                    &:nth-child(4)
                        width 110rpx
            .list-title
                height: 35rpx;
                background: rgba(255, 255, 255, 0.04);
                border-radius: 2rpx;
                border: 1px solid rgba(255, 255, 255, 0.3);
                font-size 12rpx;
                color #fff;
                span:nth-child(1)
                    font-size: 12rpx;
                .iconfont
                    font-size 10rpx!important
            .list-view
                margin 2rpx 0
                height: 35rpx;
                background: rgba(0, 145, 255, 0.04);
                border-radius: 2rpx;
                border: 1px solid rgba(0, 145, 255, 0.5);
                font-family: Technology-Regular, Technology;
                font-size: 16rpx;
                color: #0091FF;
</style>
